import { useDispatch, useSelector } from 'react-redux';
import Index from './steps/Index';
import { setStep } from '../features/providers/dataSlice';

const FormWrapper = () => {
  const dispatch = useDispatch();
  const mainTitle = useSelector((state) => {
    return state.data.mainTitle;
  });

  const disableNext = useSelector((state) => {
    return state.data.disableNext;
  });
  const disablePrev = useSelector((state) => {
    return state.data.disablePrev;
  });

  const step = useSelector((state) => {
    return state.data.step;
  });

  return (
    <div className="shadow-xl border-2 border-pink rounded-[10px] mb-20 overflow-hidden">
      <div className="p-5">
        <h1 className="text-h1 font-bold text-primary mb-10">{mainTitle}</h1>
        <Index step={step} />
      </div>
      <div className="bg-pink py-5 px-10 flex justify-between">
        <button
          onClick={() => dispatch(setStep(step - 1))}
          disabled={disablePrev[step]}
          className="text-white text-h3 font-bold btn outline !font-normal transition extra-padding"
        >
          Back
        </button>
        <button
          onClick={() => dispatch(setStep(step + 1))}
          disabled={disableNext[step]}
          className="text-white btn btn-primary text-h3 font-bold !font-normal transition extra-padding"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default FormWrapper;
